export default __webpack_public_path__ + "static/media/down-arrow-circle.b2183f00.svg";